// extracted by mini-css-extract-plugin
module.exports = {"loading":"CardLoading_loading__OzSpj"};